import {
  take,
  put,
  select,
  takeLatest,
  cancel,
  race,
  call,
} from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import * as workslotInsert from '../requests/workslot-insert-req';
import * as workslotUpdate from '../requests/workslot-update-req';
import * as intersections from '../requests/intersection-counts-req';
import { SCHEDULE_VALIDATE_TYPES, scheduleValidateActions } from '../validate';
import {
  selectSchedulePopoverData,
  selectSchedulePopoverDataId,
} from '../selectors';
import { RECURSION_MODAL_TYPES } from '../../../components/ProviderCalendar/constants';
import {
  isLastDayOfRepeat,
  repeatScheduleAdapter,
} from '../../../utils/schedule/repeat-schedule-adapter';
import { findIntersections } from './find-intersections-saga';

function* insertOrUpdateWorkSlot(payload) {
  // const selected = yield select(selectSchedulePopoverData);
  // const isRepeatable = get(selected, 'isRepeatable');
  // const slotId = get(selected, 'id');
  //
  // /** UPDATE FLOW */
  // if (slotId && !isRepeatable) {
  //   yield put(workslotUpdate.actions.send({ ...payload, slotId }));
  //   yield cancel();
  // }

  yield put(workslotInsert.actions.send(payload));
}

function* handleRecursion({ payload }) {
  const { workSlot: scheduleFormData, id } = payload;
  const selectedSchedule = yield select(selectSchedulePopoverData);

  yield put(
    scheduleValidateActions.toggleRecursionModal({
      opened: true,
      lastDay: isLastDayOfRepeat(selectedSchedule),
      type: RECURSION_MODAL_TYPES.EDIT_WORK_SLOT,
    }),
  );

  const {
    payload: { option: recursionOption },
  } = yield take(SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);

  const formattedData = repeatScheduleAdapter(
    recursionOption,
    selectedSchedule,
    scheduleFormData,
  );

  if (!formattedData) {
    yield cancel();
  }

  const slotData = { id, workSlot: formattedData };

  const canInsert = yield call(findIntersections, slotData);
  if (canInsert) {
    yield call(insertOrUpdateWorkSlot, slotData);
  }
}

function* handleStartWorkslotInserting(action) {
  const selectedSchedule = yield select(selectSchedulePopoverData);
  const isRepeatable = get(selectedSchedule, 'isRepeatable');

  if (isRepeatable) {
    yield call(handleRecursion, action);
    yield cancel();
  }

  const canInsert = yield call(findIntersections, action.payload);
  if (canInsert) {
    yield call(insertOrUpdateWorkSlot, action.payload);
  }
}

export default function* workslotInsertSaga() {
  yield takeLatest([workslotInsert.consts.START], handleStartWorkslotInserting);
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/workslot-insert-saga.js